const Dashboard = "/";
const Login = "/login";
const Admins = "/admins";
const AdminsCreate = "/admins/create";
const AdminsDetail = "/admins/:id";
const AdminsInvite = "/admins/invite";
const NotFound = "*";

// 도장 정보 관리
const CompanyStamp = "/company-stamp";
const CompanyStampDetail = "/company-stamp/:id";
const CompanyStampUpdate = "/company-stamp/update";

// 구독 상품 관리
const Subscription = "/subscription";
const SubscriptionCreate = "/subscription/create";
const SubscriptionDetail = "/subscription/:id";
const SubscriptionUpdate = "/subscription/update";

// 템플릿 관리
const Template = "/template";
const TemplateCreate = "/template/create";
const TemplateDetail = "/template/:id";
const TemplateUpdate = "/template/update";

// 분할결제 설정 관리
const InstallmentSetting = "/installment-setting";
const InstallmentSettingCreate = "/installment-setting/create";
const InstallmentSettingDetail = "/installment-setting/:id";

// 이메일 대량 발송 관리
const BulkEmail = "/bulk-email";
const BulkEmailSend = "/bulk-email/send";

// QNA 챗봇 컨텐츠 관리
const SuperChatContent = "/chat/content";
const SuperChatContentCreate = "/chat/content/create";
const SuperChatContentDetail = "/chat/content/:id";
const SuperChatContentCreateContent = "/chat/qna-content-create";
const SuperChatContentCreatePrompt = "/chat/qna-prompt-create";
const SuperChatPromptDetail = "/chat/prompt/:id";

// QNA 챗봇 로그 관리
const SuperChatLogDashboard = "/chat/log";
const SuperChatLogSessions = "/chat/log/sessions";
const SuperChatLogSessionDetail = "/chat/log/sessions/:sessionId";

// Prompt Template Management
const PromptTemplate = "/prompt-template";
const PromptTemplateCreate = "/prompt-template/create";
const PromptTemplateDetail = "/prompt-template/:id";

// Boss Baby Chat Log
const BossBabyChatLogSessions = "/boss-baby-chat-log/sessions";
const BossBabyChatLogSessionDetail =
  "/boss-baby-chat-log/sessions/:sessionUuid";

// Boss Baby Prompt Template (boss_baby_chat 키로 필터링)
const BossBabyPromptTemplate = "/boss-baby/prompt-template";
const BossBabyPromptTemplateCreate = "/boss-baby/prompt-template/create";
const BossBabyPromptTemplateDetail = "/boss-baby/prompt-template/:id";

// Boss Baby Tool Management
const BossBabyToolList = "/boss-baby/tools";
const BossBabyToolCreate = "/boss-baby/tools/create";
const BossBabyToolEdit = "/boss-baby/tools/:toolId/edit";

// Boss Baby Task Management
const BossBabyTaskList = "/boss-baby/tasks";
const BossBabyTaskCreate = "/boss-baby/tasks/create";
const BossBabyTaskEdit = "/boss-baby/tasks/:taskId/edit";

// Boss Baby Company Settings
const BossBabyCompanySettings = "/boss-baby/company-settings";

// OCI AI Test Management
const OciAiTest = "/oci-ai-test";
const OciAiTestChat = "/oci-ai-test/chat";
const OciAiTestCompare = "/oci-ai-test/compare";
const OciAiTestTranslate = "/oci-ai-test/translate";
const OciAiTestModels = "/oci-ai-test/models";

// AI Manager 관리
const AiManager = "/ai-manager";

export default {
  Dashboard,
  Login,
  Admins,
  AdminsCreate,
  AdminsDetail,
  NotFound,
  CompanyStamp,
  CompanyStampDetail,
  CompanyStampUpdate,
  Subscription,
  SubscriptionCreate,
  SubscriptionDetail,
  SubscriptionUpdate,
  Template,
  TemplateCreate,
  TemplateDetail,
  TemplateUpdate,
  InstallmentSetting,
  InstallmentSettingCreate,
  InstallmentSettingDetail,
  AdminsInvite,
  BulkEmail,
  BulkEmailSend,
  SuperChatContent,
  SuperChatContentCreate,
  SuperChatContentDetail,
  SuperChatContentCreateContent,
  SuperChatContentCreatePrompt,
  SuperChatPromptDetail,
  SuperChatLogDashboard,
  SuperChatLogSessions,
  SuperChatLogSessionDetail,
  PromptTemplate,
  PromptTemplateCreate,
  PromptTemplateDetail,
  BossBabyChatLogSessions,
  BossBabyChatLogSessionDetail,
  BossBabyPromptTemplate,
  BossBabyPromptTemplateCreate,
  BossBabyPromptTemplateDetail,
  BossBabyToolList,
  BossBabyToolCreate,
  BossBabyToolEdit,
  BossBabyTaskList,
  BossBabyTaskCreate,
  BossBabyTaskEdit,
  BossBabyCompanySettings,
  OciAiTest,
  OciAiTestChat,
  OciAiTestCompare,
  OciAiTestTranslate,
  OciAiTestModels,
  AiManager,
};
